import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function MapIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 8.96875 2.9355469 L 3.6289062 5.0722656 C 3.2489063 5.2242656 3 5.591 3 6 L 3 20 C 3 20.707 3.7140937 21.190734 4.3710938 20.927734 L 9.03125 19.064453 L 15.03125 21.064453 L 20.371094 18.927734 C 20.751094 18.775734 21 18.409 21 18 L 21 4 C 21 3.293 20.285906 2.8092656 19.628906 3.0722656 L 14.96875 4.9355469 L 8.96875 2.9355469 z M 10 5.3867188 L 14 6.7207031 L 14 18.613281 L 10 17.279297 L 10 5.3867188 z M 8 5.4765625 L 8 17.322266 L 5 18.523438 L 5 6.6777344 L 8 5.4765625 z M 19 5.4765625 L 19 17.322266 L 16 18.523438 L 16 6.6777344 L 19 5.4765625 z" />
        </SvgIcon>
    );
}
